// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"46186300","885":"17167d81"}[chunkId] + ".chunk.js";
};